export const POPULAR = { categoryId: -2, order: -2, name: 'model.popular' };
export const FAVORITE = { categoryId: -1, order: -1, name: 'model.favorite' };

const SIDE_BAR_WIDTH = 0;
const MAIN_PADDING = 2;
const FILTER_WIDTH = 0;

export const modelLayout = {
    sidebarWidthPercent: SIDE_BAR_WIDTH,

    filterWidthPercent: FILTER_WIDTH,
    // mainMarginPercent: 15,
    mainMarginPercent: MAIN_PADDING,
    mainPaddingPercent: MAIN_PADDING,
    mainWidthPercent: 100 - SIDE_BAR_WIDTH
};

const DETAIL_SIDE_BAR_WIDTH = 10;
const DETAIL_MAIN_PADDING = DETAIL_SIDE_BAR_WIDTH * 0.5 + 2;
const DETAIL_FILTER_WIDTH = DETAIL_SIDE_BAR_WIDTH + MAIN_PADDING;
export const detailLayout = {
    sidebarWidthPercent: DETAIL_SIDE_BAR_WIDTH,

    filterWidthPercent: DETAIL_FILTER_WIDTH,
    mainMarginPercent: 15,

    mainPaddingPercent: DETAIL_MAIN_PADDING,
    mainWidthPercent: 100 - DETAIL_SIDE_BAR_WIDTH
};

export const headerDiv = {
    right: 50
};

export const stickyHeight = 40;

export const RESIZABLE_HEADER_DATA = 'RESIZABLE_HEADER_DATA';

export const PHONE_MASK_ID = 'phone-mask-id';

export const BORDER_SIZE = 0;
export const RATIO = 2.018369754508174;
export const INTERNAL_RATIO = 2.159792181461066;
export const OUTER_WIDTH_RATIO = 1.5 * 0.113364417729341;
export const OUTER_HEIGHT_RATIO = 1.5 * 0.065239945447967;

export const PHONE_IMAGE_W = 15;
export const PHONE_IMAGE_H = PHONE_IMAGE_W * INTERNAL_RATIO;
export const MAX_PHONE_IMAGE_W = 200;
export const MAX_PHONE_IMAGE_H = MAX_PHONE_IMAGE_W * INTERNAL_RATIO;

export const PHONE_BORDER_IMAGE_W = PHONE_IMAGE_W + 1.5 * OUTER_WIDTH_RATIO * PHONE_IMAGE_W;
export const PHONE_BORDER_IMAGE_H =
    PHONE_IMAGE_W * RATIO + 1.5 * OUTER_HEIGHT_RATIO * RATIO * PHONE_IMAGE_W;

export const MAX_PHONE_BORDER_IMAGE_W =
    MAX_PHONE_IMAGE_W + 1.5 * OUTER_WIDTH_RATIO * MAX_PHONE_IMAGE_W;
export const MAX_PHONE_BORDER_IMAGE_H =
    MAX_PHONE_IMAGE_W * RATIO + 1.5 * OUTER_HEIGHT_RATIO * RATIO * MAX_PHONE_IMAGE_W;

export const BORDER_IMAGE_SLICE = BORDER_SIZE;

export const modelPhoneLayout = {
    width: PHONE_IMAGE_W,
    height: PHONE_IMAGE_H,
    maxWidth: MAX_PHONE_IMAGE_W,
    maxHeight: MAX_PHONE_IMAGE_H
};
export const borderPhoneLayout = {
    width: PHONE_BORDER_IMAGE_W,
    height: PHONE_BORDER_IMAGE_H,
    maxWidth: MAX_PHONE_BORDER_IMAGE_W,
    maxHeight: MAX_PHONE_BORDER_IMAGE_H
};

export const BORDER_PHONE_IMAGE_H = 50;

export const SMALL_PHONE_IMAGE_W = BORDER_PHONE_IMAGE_H / RATIO;
export const SMALL_PHONE_IMAGE_H = BORDER_PHONE_IMAGE_H;
export const SMALL_PHONE_BORDER_IMAGE_W =
    BORDER_PHONE_IMAGE_H / RATIO + (OUTER_WIDTH_RATIO * BORDER_PHONE_IMAGE_H) / RATIO;
export const SMALL_PHONE_BORDER_IMAGE_H =
    BORDER_PHONE_IMAGE_H + OUTER_HEIGHT_RATIO * BORDER_PHONE_IMAGE_H;

export const smallModelPhoneLayout = {
    borderWidth: SMALL_PHONE_BORDER_IMAGE_W,
    borderHeight: SMALL_PHONE_BORDER_IMAGE_H,
    width: SMALL_PHONE_IMAGE_W,
    height: SMALL_PHONE_IMAGE_H
};

const IFRAME_WIDTH = 15;
const IFRAME_PADDING = 2;

export const detailModelLayout = {
    sidebar: SIDE_BAR_WIDTH,
    iframeWidth: IFRAME_WIDTH,
    iframeHeight: IFRAME_WIDTH * RATIO,
    iframePadding: IFRAME_PADDING,
    iframeBorderWidth: IFRAME_WIDTH + 1.5 * OUTER_WIDTH_RATIO * IFRAME_WIDTH,
    iframeBorderHeight: IFRAME_WIDTH * RATIO + 1.5 * OUTER_HEIGHT_RATIO * IFRAME_WIDTH * RATIO,
    mainWidthPercent: 100 - IFRAME_WIDTH
};
